export default {
  DEFAULT: { x: 3, y: 4, z: 8.5, _x: 0, _y: 0, _z: 0 },
  HOME_ZOOM: {
    x: 0.4226915063867805,
    y: 0.9173406390351284,
    z: 2.078470181842371,
    _x: -0.08861077948998768,
    _y: 0.5241708098872303,
    _z: -0.2821844891225064,
  },
  ZOOM_IN_1: {
    x: 0.34462566143723866,
    y: 0.8573113065464888,
    z: 1.718044448155407,
    _x: -0.08861077948998768,
    _y: 0.5241708098872303,
    _z: -0.2821844891225064,
  },
  ZOOM_OUT_1: {
    x: 0.5413922833021995,
    y: 1.008616515299851,
    z: 2.6265051725172976,
    _x: -0.08861077948998768,
    _y: 0.5241708098872303,
    _z: -0.2821844891225064,
  },
};
